export default class ChangedMatchesModifier {
    constructor(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }

    modify(content) {
        if (content.events === undefined || content.events.change === undefined) {
            return;
        }

        const matches = content.events.change;

        for (let i = 0; i < matches.length; i++) {
            const match = matches[i];

            const key = this._modelKeyRepository.getMatchKey(match.id);

            matches[i] = Object.assign({
                name: match.n,
                notice: match.ntc
            }, key);
        }
    }
}



// WEBPACK FOOTER //
// ./js/repositories/modifier/ChangedMatchesModifier.js